<template>
  <div>
    <v-dialog v-model="visible" max-width="800px">
      <v-card>
        <v-toolbar color="#f9f9f9">
          <v-toolbar-title>确定将以下被保险人减员吗？</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-data-table :headers="headers" :items="checkedDate" hide-actions class="employee-table">
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{props.item.name}}</td>
                <td v-if="props.item.relation === 1">本人</td>
                <td v-else-if="props.item.relation === 10">配偶</td>
                <td v-else-if="props.item.relation === 40">子女</td>
                <td>{{props.item.identifyNumber}}</td>
                <td>{{props.item.mobile}}</td>
                <td>{{props.item.effectDate}}</td>
                <td>{{props.item.price}}</td>
              </tr>
            </template>
          </v-data-table>
          <v-layout class="mt-4 column">
            <v-layout justify-end>
              <p>
                总保费：
                <span>
                  ￥
                  <strong>-{{price}}</strong>
                </span>
              </p>
            </v-layout>
            <v-layout justify-end>
              <strong style="color:#F8952A;font-size:14px;">保费将退回交费的银行卡中</strong>
            </v-layout>
            <v-layout justify-end class="mt-4">
              <v-btn @click="visible = false">取消</v-btn>
              <v-btn color="primary" @click="childMethod()">确定</v-btn>
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    checkedDate: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      headers: [
        {
          text: "姓名",
          value: "name",
          sortable: false
        },
        {
          text: "与员工关系",
          value: "relation",
          sortable: false
        },
        {
          text: "证件号码",
          value: "idCard",
          sortable: false
        },
        {
          text: "手机号",
          value: "phone",
          sortable: false
        },
        {
          text: "生效日期",
          value: "startDate",
          sortable: false
        },
        {
          text: "保费",
          value: "price",
          sortable: false
        }
      ]
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    price() {
      let price = 0;
      this.checkedDate.map(item => {
        price += Number(item.price);
      });
      return price;
    }
  },
  methods: {
    childMethod(){
      this.visible = false;
      this.$emit('fatherMethod');
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-list {
  .notice-list-link {
    color: inherit;
    text-decoration: none;
  }
}
</style>